import React, { useState, useEffect, useRef } from 'react';
import {
    Row, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText,
    Button
} from 'reactstrap';
import AccountCard from './AccountCard';
import AccountTable from './AccountTable';
import { getAccounts, deleteAccount } from '../../API';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTable, faPause } from '@fortawesome/free-solid-svg-icons';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';

function Accounts(props) {
    const [layout, setLayout] = useState(localStorage.accountSearchLayout || 'card');
    const [searchOptions, setSearchOptions] = useState({ active: 1 });
    const [localAccountsStore, setLocalAccountsStore] = useState([]);
    const [searchTimeout, setSearchTimeout] = useState(false);
    const searchOptionsRef = useRef(searchOptions);
    const searchTimeoutRef = useRef(searchTimeout);
    const [accounts, setAccounts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    searchOptionsRef.current = searchOptions;
    searchTimeoutRef.current = searchTimeout;

    //Automatically search when a search option updates (at most evry 500ms).
    useEffect(() => {
        const timeoutSearch = async () => {
            await search();
        };

        const timeout = setTimeout(timeoutSearch, 500);

        return (() => clearTimeout(timeout));
    }, [searchOptions]);

    const search = async () => {
        setIsLoading(true);
        //const searchLocalResults = localAccountsStore.filter(o => {
        //    return (!searchOptions.accountNumber || o.accountNumber.toLowerCase() == searchOptions.accountNumber.toLowerCase())
        //        && (!searchOptions.account || o.name.toLowerCase().includes(searchOptions.account.toLowerCase()))
        //        && (!searchOptions.contact || (o.contactFirst.toLowerCase() + ' ' + o.contactLast.toLowerCase()).includes(searchOptions.contact.toLowerCase()))
        //        && (searchOptions.active == -1 || (searchOptions.active == 1 && o.active) || (searchOptions.active == 0 && !o.active));
        //});
        //setAccounts(searchLocalResults);
        //Call API
        //const searchAPIResults = store.accounts.filter(o => {
        //    return (!searchOptionsRef.current.accountNumber || o.accountNumber.toLowerCase().includes(searchOptionsRef.current.accountNumber.toLowerCase()))
        //        && (!searchOptionsRef.current.account || o.name.toLowerCase().includes(searchOptionsRef.current.account.toLowerCase()))
        //        && (!searchOptionsRef.current.contact || (o.contactFirst.toLowerCase() + ' ' + o.contactLast.toLowerCase()).includes(searchOptionsRef.current.contact.toLowerCase()))
        //        && (searchOptionsRef.current.active == -1 || (searchOptionsRef.current.active == 1 && o.active) || (searchOptionsRef.current.active == 0 && !o.active));
        //});

        const searchAPIResults = await getAccounts(searchOptionsRef.current);
        setAccounts(searchAPIResults);

        //setLocalAccountsStore([...localAccountsStore, ...searchAPIResults.filter(o => !localAccountsStore.some(l => l.id == o.id))]);
        setIsLoading(false);
    };

    const updateSearch = e => {
        setSearchOptions({
            ...searchOptions,
            [e.target.name]: e.target.value
        });
    };

    const deleteAccountRecord = async (accountId) => {
        if (await deleteAccount(accountId))
            search();
        else
            console.log('Unable to delete this record.');
    };

    const toggleLayout = (type) => {
        localStorage.accountSearchLayout = type;
        setLayout(type);
    }

    const accountsListLayoutJSX = layout === 'card' ? (
        <div className="action-icon tooltip-parent" onClick={() => toggleLayout('table')}>
            <FontAwesomeIcon icon={faTable} />
            <div className="tooltip-target">
                Table View
            </div>
        </div>
    ) : (
        <div className="action-icon tooltip-parent" onClick={() => toggleLayout('card')}>
            <FontAwesomeIcon icon={faPause} rotation={90} />
            <div className="tooltip-target">
                Card View
            </div>
        </div>
    );

    let accountsJSX = (<div>No Accounts Found...</div>);
    if (isLoading) {
        accountsJSX = (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>);
    } else if (accounts !== null && accounts.length > 0) {
        if (layout === 'card')
            accountsJSX = accounts.map(o => (<AccountCard account={o} key={o.accountID} deleteRecord={async () => await deleteAccountRecord(o.accountID)} />));
        else
            accountsJSX = <AccountTable accounts={accounts} deleteRecord={deleteAccountRecord} />
    }

    return (
        <div id="accounts">
            <Row className="title-row">
                <Col>
                    <h1>Accounts</h1>
                </Col>
            </Row>
            <Row className="search-row">
                <Col>
                    <Row xs={1} md={2} lg={3} xl={4}>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-check-square"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="select" name="active" value={searchOptions.active} onChange={updateSearch}>
                                        <option value={1}>Active</option>
                                        <option value={0}>Inactive</option>
                                        <option value={-1}>Any</option>
                                    </Input>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-asterisk"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Account Number" name="accountNumber" value={searchOptions.accountNumber} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-city"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Account" name="account" value={searchOptions.account} onChange={updateSearch}/>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-user"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Contact" name="contact" value={searchOptions.contact} onChange={updateSearch}/>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-map-marker-alt"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Address" name="address" value={searchOptions.address} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-hashtag"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Permit Number" name="permitNumber" value={searchOptions.permitNumber} onChange={updateSearch}/>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row xs={1} md={2} lg={3} xl={4}>
                        <Col className="col" md={{ span: 6, offset: 6 }} lg={{ span: 4, offset: 8 }} xl={{ span: 3, offset: 9 }}>
                            <Button className="btn-block btn-icon" color="danr-green" onClick={search}><i className="fas fa-search"></i><span>Search</span></Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="actions-row">
                <Col>
                    <div className="search-actions">
                        {accountsListLayoutJSX}
                        {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                            <Link to="/admin/accounts/add" className="action-icon action-add tooltip-parent">
                                <i className="fas fa-plus"></i>
                                <div className="tooltip-target">
                                    Add Account
                                </div>
                            </Link>
                        ) : null}
                    </div>
                </Col>
            </Row>
            <Row className="results-row">
                <Col>
                    {accountsJSX}
                </Col>
            </Row>
        </div>
    );
}

export default Accounts;